module.exports = __webpack_public_path__ + "img/missionaries15_2019_7-7-2021.a0007667.jpg";